import * as SharedAcross from '../utilities/SharedAcross';
import DropDownMenuForSlider from './DropDownMenuForSlider';
import * as EditorHelpers from '../utilities/EditorHelpers';
import * as StyleFunctions from '../utilities/StyleFunctions';

function App(props) {

  function onMouseDown(e){
    e.preventDefault();
  }

  var title = props.title;
  var origDistance = props.origDistance;
  var min = props.min;
  var max = props.max;
  var step = props.step;
  var uintChoices = props.uintChoices;
  var origUnit = props.origUnit;
  var insetWidth = props.insetWidth;
  var changeWhat = props.changeWhat;
  var insetHeight = props.insetHeight;
  var submitValueAndUnit = props.submitValueAndUnit;
  var doCombo = props.doCombo;
  var screenSize = props.screenSize;

  var origDistanceOut = origDistance;
  var additionalInfo = null;

  function baselineDistance(origDistance){
      if (origDistance){
        return origDistance.v;
      }else if (changeWhat === 'colWidth'){
        return 3;
      }else{
        return 0;
      }
  }

  var reference = 'v';

  if (origUnit === 'bsu' || (!origUnit && (changeWhat === 'colWidth' || changeWhat === 'colWidthInternal' || changeWhat === 'ml' || changeWhat === 'mr' || changeWhat === 'mb' || changeWhat === 'mt'))){
    if (screenSize === 0){
      origDistanceOut = baselineDistance(origDistance);
      additionalInfo = <div>If you would like to modify this value for larger screen sizes, select a larger screen size icon on the top bar.</div>
//
    }else{


      var amt = StyleFunctions.minScreenSize(screenSize);
      var vDistance = baselineDistance(origDistance);
      if (!origDistance){
        origDistanceOut = vDistance;
        function addCustom1(e){
          origDistance = {t:'bsu',v:vDistance};
          origDistance[reference] = vDistance;
          submitValueAndUnit(origDistance);
        } 
        additionalInfo = <div><u style={{cursor:'pointer'}} onClick={addCustom1}>Add</u> a custom value for widths greater than {amt}px. You may change the baseline values by selecting the Extra Small Device icon on the top bar.</div>
//
      }else{
        var referenceX = StyleFunctions.sizePointer(screenSize);

        if (origDistance[referenceX] !== undefined){
          reference = referenceX;
          origDistanceOut = origDistance[reference];
          function removeCustom(e){
            delete origDistance[reference];
            submitValueAndUnit(origDistance);
          }
          additionalInfo = <div>Baseline value is {vDistance}, which can be modified by selecting the portrait phone icon on the top bar. This modification is for screen widths greater than {amt}px. <u onClick={removeCustom} style={{cursor:'pointer'}}>Remove</u> custom value.</div>
//
        }else{
          origDistanceOut = vDistance;
          function addCustom(e){
            origDistance[referenceX] = vDistance;
            submitValueAndUnit(origDistance);
          } 
          additionalInfo = <div><u style={{cursor:'pointer'}} onClick={addCustom}>Add</u> a custom value for widths greater than {amt}px. You may change the baseline values by selecting the Extra Small Device icon on the top bar.</div>
        }

      }
    }
//
  }else if (changeWhat === 'colWidth'){
    origDistanceOut = 3;
  }
//
  var uint = uintChoices[0].t;

  if (origUnit){
    uint = origUnit;
  }

  function getValue(title, origDistanceX){
    var sel = document.getSelection();
    var pp = window.prompt('Please specify the ' + title, origDistanceX);
    if (sel.anchorNode && sel.focusNode){
      var range = document.createRange();
      range.setStart(sel.anchorNode, sel.anchorOffset);
      range.setEnd(sel.focusNode, sel.focusOffset);
      sel.removeAllRanges()
      sel.addRange(range);
    }

    if (changeWhat === 'colWidth' && !SharedAcross.isIntegerText(pp)){
      window.alert('Widths need to be integers'); 
      return null;
    }

    return pp;
  }

//
  var inputsList= uintChoices.filter((anOption, index)=>{
    return (origUnit !== 'comb' || (origUnit === 'comb' && anOption.t !== 'px'))
  }).map((anOption, index)=>{

      function changeUnit(e){
        if (origUnit === 'comb'){
          var oD = EditorHelpers.reverseScale(origDistanceOut.var.v, origDistanceOut.var.t, changeWhat, insetWidth, insetHeight);
          var nD = EditorHelpers.scaledDistance(oD, anOption.t, changeWhat, insetWidth, insetHeight);
          origDistanceOut.var = {t:anOption.t, v:nD};
          submitValueAndUnit({t:'comb', v:origDistanceOut});
        }else if (uint !== anOption.t){
          var oD1 = EditorHelpers.reverseScale(origDistanceOut, uint, changeWhat, insetWidth, insetHeight);
          var nD1 = EditorHelpers.scaledDistance(oD1, anOption.t, changeWhat, insetWidth, insetHeight);
          submitValueAndUnit({t:anOption.t, v:nD1});

        }
      }

      var tt = anOption.t;
      if (tt === 'perc'){
        tt = '%';
      }else if (tt === 'int' || tt === 'bsu'){
        tt = '';
      }
      var ann = anOption.n;
      if (tt){
        ann += ' (' + tt + ')';
      }
    return <li className="menu-item" onClick={changeUnit}>{ann}</li>
  })
//
  function useComboSwap(){
    if (origUnit === 'comb'){
      submitValueAndUnit(origDistanceOut.var);
    }else{
      var input = {var:{t:uint,v:origDistanceOut}, fixed:0.01};
      submitValueAndUnit({t:'comb', v:input})
    }
  }
//
//
  if (origUnit === 'comb'){
    var inputsListFixed = [<li className="menu-item" >px</li>];
//
    function changeSomethingSubVar(e){
      origDistanceOut.var.v = +e.target.value;
      submitValueAndUnit({t:'comb', v:origDistanceOut});
    }

    function changeSomethingFixedVar(e){
      origDistanceOut.fixed = +e.target.value;
      submitValueAndUnit({t:'comb', v:origDistanceOut});
    }

    function specifySubVarDistanceDirectly(e){
      var pp = getValue('Font Size in ' + origDistanceOut.var.t, origDistanceOut.var.v);
      if (pp === undefined || pp === null){
      }else if (uint !== 'int' && !SharedAcross.isDecimalText(pp)){
        window.alert('Need a positive number');
        return;
      }else if (+pp >= 0 && +pp <= max){
        origDistanceOut.var.v = +pp;
        submitValueAndUnit({t:'comb', v:origDistanceOut});

      }else{
        window.alert('Number needs to be between ' + min + ' and ' + max);
        return;
      }

    }

   function specifySubFixedDistanceDirectly(e){
      var pp = getValue('Minimum Font Size in px', origDistanceOut.fixed);
      if (pp === undefined || pp === null){
      }else if (uint !== 'int' && !SharedAcross.isDecimalText(pp)){
        window.alert('Need a positive number');
        return;
      }else if (+pp >= 0 && +pp <= max){
        origDistanceOut.fixed = +pp;
        submitValueAndUnit({t:'comb', v:origDistanceOut});

      }else{
        window.alert('Number needs to be between ' + min + ' and ' + max);
        return;
      }

    }

//

//
    var varSliderPart = <div className="range-slider" >
      <input type='range' className="range-slider__range" style={{width:'150px'}} value={origDistanceOut.var.v} step={step} min={min} max={max} onChange={changeSomethingSubVar}/>

            <div className="sliderinputsnew" onMouseDown={onMouseDown}>
              <span className="sliderinputtext" onClick={specifySubVarDistanceDirectly}>{limitNosSig(origDistanceOut.var.v, step)}</span>
              <DropDownMenuForSlider selectText={origDistanceOut.var.t} inputsList={inputsList} />
            </div>        
        </div>


    var fixedSliderPart = <div className="range-slider" >
      <input type='range' className="range-slider__range" style={{width:'150px'}} value={origDistanceOut.fixed} step={step} min={min} max={max} onChange={changeSomethingFixedVar}/>

            <div className="sliderinputsnew" onMouseDown={onMouseDown}>
              <span className="sliderinputtext" onClick={specifySubFixedDistanceDirectly}>{limitNosSig(origDistanceOut.fixed, step)}</span>
              <DropDownMenuForSlider selectText={'px'} inputsList={inputsListFixed} />
            </div>        
        </div>


      return <div>{varSliderPart}
              Minimum Size<br/>(Final Font size is the sum of the font size above + the fixed size component specified below)<br/>
              {fixedSliderPart}
              <div style={{cursor:'pointer'}} onClick={useComboSwap} onMouseDown={onMouseDown}><u>Remove Minimum Size</u></div>
            </div>
// //
  }else{

    function updateValue(newValue){
      if (origUnit === 'bsu'){
        if (!origDistance){
          origDistance = {t:'bsu', v:3};
        }
        origDistance[reference] = newValue;
        submitValueAndUnit(origDistance);
      }else{
        submitValueAndUnit({t:uint, v:newValue});
      }
    }
    function specifyDistanceDirectly(){
      var pp = getValue(title, origDistanceOut);
      if (pp === undefined || pp === null){
      }else if (uint === 'int' && !SharedAcross.isIntegerText(pp)){
        window.alert('Need a positive integer');
        return;
      }else if (uint !== 'int' && !SharedAcross.isDecimalText(pp)){
        window.alert('Need a positive number');
        return;
      }else if (uint === 'px' || uint === 'em' || uint === 'vh' || uint === 'vw'){
        updateValue(+pp);
      }else if (+pp >= min && +pp <= max){
        updateValue(+pp);
      }else{
        window.alert('Number needs to be between ' + min + ' and ' + max);
        return;
      }
    }

    function changeSomething(e){
      updateValue(+e.target.value);
    }

    var uintDisp = uint;
    if (uint === 'bsu' || uint === 'int'){
      uintDisp = '-'
    }else if (uint === 'perc'){
      uintDisp = '%';
    }

    function nothing(e){
      e.stopPropagation();
    }

    var sliderPart = <div className="range-slider" onMouseDown={nothing}>
      <input type='range' className="range-slider__range" style={{width:'150px'}} value={origDistanceOut} step={step} min={min} max={max} onChange={changeSomething}/>

            <div className="sliderinputsnew" onMouseDown={onMouseDown}>
              <span className="sliderinputtext" onClick={specifyDistanceDirectly}>{limitNosSig(origDistanceOut, step)}</span>
              <DropDownMenuForSlider selectText={uintDisp} inputsList={inputsList} />
            </div>        
        </div>

    var addPiece;
    if (doCombo){
      if (uint === 'px'){
      }else{
        addPiece = <div style={{cursor:'pointer'}} onMouseDown={onMouseDown} onClick={useComboSwap}><u>Add Minimum Size</u></div>
      }
    }


    return <div>{additionalInfo}{sliderPart}{addPiece}
          </div>

  }
//
}

function limitNosSig(text, step){
  if (step >= 1){
    return (+text).toFixed(0);
  }
  return (+text).toFixed(2);
}

//
export default App;
